import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import type { District } from '../types';
import { apiClient } from '@/_config/lib/axios/api-client';

type GetNeighborhoodsParams = {
  generalCityId: string;
};

const getNeighborhoods = (params: GetNeighborhoodsParams) => {
  const { generalCityId } = params;

  return apiClient
    .get<District[]>(`/municipios/${generalCityId}/import-neighborhoods`)
    .then(response => {
      return response.data;
    })
    .catch(handleResponseThrowError('Não foi possível carregar os bairros'));
};

type GetNeighborhoodsResponse = Awaited<ReturnType<typeof getNeighborhoods>>;

export const useImportNeighborhoods = (
  params: GetNeighborhoodsParams,
  options: Omit<
    UseQueryOptions<
      GetNeighborhoodsResponse,
      unknown,
      GetNeighborhoodsResponse,
      (string | GetNeighborhoodsParams)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: ['GET_NEIGHBORHOODS', params],
    queryFn: () => getNeighborhoods(params),
    ...options,
  });
};
